import type {
  AgentPlatformAi,
  InventoryPlatformAi
} from "./agent-platform.types"

export const AGENT_PLATFORMS: AgentPlatformAi[] = [
  "AGENTCORE",
  "COPILOT_STUDIO"
]

export const AGENT_PLATFORM_LABELS: Record<AgentPlatformAi, string> = {
  AGENTCORE: "AgentCore",
  COPILOT_STUDIO: "Copilot Studio"
}

export const isAgentPlatform = (value: string): value is AgentPlatformAi =>
  AGENT_PLATFORMS.some((platform) => platform === value)

// A policy cannot be scoped to a Kubernetes cluster or a VM, so each is an
// inventory platform but no agent platform
export const INVENTORY_PLATFORMS: InventoryPlatformAi[] = [
  ...AGENT_PLATFORMS,
  "KUBERNETES",
  "VM"
]

export const INVENTORY_PLATFORM_LABELS: Record<InventoryPlatformAi, string> = {
  ...AGENT_PLATFORM_LABELS,
  KUBERNETES: "Kubernetes",
  VM: "VM"
}

const normalizePlatform = (value: string | null | undefined) =>
  (value || "").toUpperCase().replace(/[\s-]+/g, "_")

// The APIs name a platform by its enum (AI_AGENT_PLATFORM_AGENTCORE), its key
// (AGENTCORE) or its display name (Copilot Studio)
export const getAgentPlatformKey = (
  value: string | null | undefined
): AgentPlatformAi | undefined => {
  const normalized = normalizePlatform(value)

  return AGENT_PLATFORMS.find((platform) => normalized.endsWith(platform))
}

export const getInventoryPlatformKey = (
  value: string | null | undefined
): InventoryPlatformAi | undefined => {
  const normalized = normalizePlatform(value)

  return INVENTORY_PLATFORMS.find((platform) => normalized.endsWith(platform))
}
